import React from 'react'
import { MobilePaginationBar } from '../../components/mobile'

const RefundMobilePagination = ({ pagination, handlePagination }) => {
  return (
    <MobilePaginationBar
      current_page={pagination?.current_page}
      total_pages={pagination?.total_pages}
      onNavigate={handlePagination}
      ariaLabel="Paginación de devoluciones"
      disablePaper
    />
  )
}

export default RefundMobilePagination
